import tinycolor from 'tinycolor2';
import {
  focusOutline,
  getOneColorState,
  responsive,
  spacing,
  ThemeUICSSObject,
} from '@apia/theme';
/* IMPORT HERE */

const scheduler: ThemeUICSSObject = {
  variant: 'layout.execution.form.fields.field',

  details: {
    '.no__appoinments': {
      border: '1px solid',
      borderColor: 'palette.border.field',
      padding: '10px',
      borderRadius: 'default',
    },
    '.appoinments__details': {
      borderRadius: 'default',
      borderCollapse: 'collapse',
      width: '100%',
      textAlign: 'left',
      border: '1px solid',
      borderColor: 'palette.border.field',
      'th, .appoinments__details_id': {
        fontWeight: 'bold',
        border: '1px solid',
        borderColor: 'palette.border.field',
        padding: '10px',
      },
      '.appoinments__details_attribute': {
        border: '1px solid',
        borderColor: 'palette.border.field',
        padding: '5px',
        minWidth: '200px',
      },
    },
  },

  '&.scheduler': {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    textAlign: 'center',
    '.selectedDateInfo': {
      margin: '5px',
      minHeight: '25px',
      display: 'flex',
      justifyContent: 'center',
    },
    '.delete_date_button': {
      display: 'none',
    },
    table: {
      variant: 'layout.common.tables.primary',
      width: '100%',
      overflow: 'hidden',
      border: ' 1px solid',
      borderColor: 'palette.border.field',
      borderCollapse: 'collapse',
      thead: {
        'tr:not(.filtersRow)': {
          'th:first-of-type': {
            width: '80px',
          },
          th: {
            width: 'auto',
            border: 'none',
            borderColor: 'palette.primary.main',
            textAlign: 'center',
            px: 1,

            '.headButton__container': {
              display: 'flex',
              justifyContent: 'center',
            },

            '.headButton__label': {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              px: 0,
            },

            '& .headButton': {
              backgroundColor: 'palette.primary.main',
              border: 'none',
              px: 1,
              // py: 3,
              borderColor: 'palette.primary.main',
            },
          },
        },
      },

      tbody: {
        tr: {
          'td:first-of-type': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        },
        td: {
          p: 0,
          height: '40px',
          textAlign: 'center',
          alignContent: 'center',

          border: ' 1px solid',
          borderColor: 'palette.primary.main',

          '&.disabled': {
            background: (theme) =>
              getOneColorState(
                'palette.background.paper',
                'disabled',
                theme.palette,
              ),
          },

          '&:focus-within': focusOutline,
        },
      },
    },
    '.box_spinner': (theme) => ({
      position: 'relative',
      alignItems: 'center',
      justifyContent: 'center',
      alignSelf: 'center',
      width: '100%',
      height: '65%',
      marginTop: '20px',
      display: 'flex',
      background: tinycolor(theme.palette.background.paper)
        .setAlpha(0.4)
        .toRgbString(),
    }),
    '.scheduler__navigator': {
      gap: spacing(4),
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      '.scheduler__navigator_dateInput input': {
        textAlign: 'center',
        width: '380px',
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },

      '.scheduler__navigator_dateInput': {
        width: responsive({ 0: '100%', 3: 'auto', 4: '100%', 5: 'auto' }),
        order: responsive({ 0: 1, 3: 3, 4: 1, 5: 3 }),
      },
      '.scheduler__navigator_todayBtn': {
        order: responsive({ 0: 2, 3: 1, 4: 2, 5: 1 }),
      },
      '.scheduler__navigator_lastBtn': {
        order: responsive({ 0: 3, 3: 2, 4: 3, 5: 2 }),
      },
      '.scheduler__navigator_nextBtn': {
        order: responsive({ 0: 4, 3: 4, 4: 4, 5: 4 }),
      },
      '.scheduler__navigator_DeleteBtn': {
        order: responsive({ 0: 5, 3: 5, 4: 5, 5: 5 }),
      },
      '.iconInput': {
        margin: responsive({ 0: 'auto', 3: '0', 4: 'auto', 5: '0' }),
        width: responsive({
          0: 'max-content',
          1: 'auto',
          2: 'max-content',
          3: 'auto',
          4: 'max-content',
          5: 'auto',
        }),
        gap: 0,

        '.iconButton': {
          border: 'none',
          background: 'palette.background.paper',
        },
      },
      '.iconButton': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      },
    },

    '.scheduler__tskSchDisabled': {
      backgroundColor: '#b2c0cf',
      cursor: 'not-allowed',
    },
    '.schedulerMini': {
      flex: 1,
      display: responsive({ 0: 'block', 3: 'flex' }),
      alignItems: responsive({ 0: 'center', 3: 'start' }),
      justifyContent: 'center',
      flexDirection: responsive({ 0: 'column', 3: 'row' }),
      maxHeight: responsive({ 0: '100vh', 3: '60vh' }),
      gap: spacing(7),

      '.schedulerMini_faCaretDown': {
        flex: 1,
        alignSelf: 'center',
        justifyContent: 'center',
        display: responsive({ 0: 'block', 3: 'none' }),
      },
    },
    '.stage': {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: responsive({ 0: 'auto', 3: '60vh' }),
      width: responsive({ 0: '100%', 3: '60%' }),
      zIndex: 1,
      transition: 'width 1s',
    },

    '[data-name="daysList"]': {
      transition: 'transform 0.5s, opacity 0.8s',
      transform: responsive({ 0: 'translateY(-10%)', 3: 'translateY(-40%)' }),
      opacity: 0,
      width: 0,
    },
    '[data-name="morningOrAfternoon"]': {
      transition: 'transform 0.5s, opacity 0.8s',
      transform: responsive({ 0: 'translateY(-10%)', 3: 'translateY(-40%)' }),
      opacity: 0,
      width: 0,
    },
    '[data-name="daysHours"]': {
      transition: 'transform 0.5s, opacity 0.8s',
      transform: responsive({ 0: 'translateY(-10%)', 3: 'translateY(-40%)' }),
      opacity: 0,
      width: 0,
    },

    '.stage.in.visible': {
      opacity: 1,
      transform: responsive({ 0: 'translateY(0)', 3: 'translateY(0)' }),
      width: responsive({ 0: '100%', 3: '60%' }),
    },
    '[data-name="daysList"] .stage.in.visible': {
      opacity: 1,
      transform: responsive({ 0: 'translateY(0)', 3: 'translateY(0)' }),
      width: responsive({ 0: '100%', 3: '60%' }),
    },

    '.stage:nth-of-type(3)': {
      maxHeight: responsive({ 0: 'auto', 3: '60vh' }),
      overflow: responsive({ 0: 'none', 3: 'auto' }),
    },
    '.stage_btn': {
      margin: '2px',

      '&.selected': {
        position: 'sticky',
        top: 0,
        variant: 'buttons.primary',

        bottom: 0,
        zIndex: 1,
      },

      '&:disabled:hover': {
        backgroundColor: 'palette.gray.800',
        color: 'palette.common.black',
      },
    },
    '.stage_btn:disabled': {
      display: responsive({ 0: 'none', 3: 'block' }),
    },

    '.td_overassign': {
      backgroundColor: 'palette.warning.main',
    },
  },
  '.schd__info_disabledColor': {
    background: (theme) =>
      getOneColorState('palette.background.paper', 'disabled', theme.palette),
    '&:hover, &:focus, &:active': {
      background: (theme) =>
        getOneColorState('palette.background.paper', 'disabled', theme.palette),
    },
  },

  '.scheduler_cell': {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    button: {
      width: '100%',
      height: '100%',
    },

    '*:focus': {
      outline: 'none',
    },
  },

  /* PREPEND HERE */
};

export default scheduler;
